var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Aprobaciones pendientes"},on:{"click":function($event){_vm.menu = 0;}}},[_c('Lista_aprobar')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }